import React from "react";
import SyncLoader from "react-spinners/SyncLoader";

export default function Loader({message}:{message:string}) {
  return (
    <section className="loader">
      <p>{message}</p>
      <SyncLoader color="#E53526" size={25}/>
    </section>
  );
}
